/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AuthTransferOutRequest = {
  /**
   * The target platform host to transfer the session to (e.g. ai.speakeasy.com)
   */
  targetHost?: string | undefined;
  /**
   * The browser binding nonce from the target host's transferIn start mode
   */
  nonce?: string | undefined;
  /**
   * Optional URL path to redirect to after the transfer completes on the target host
   */
  redirect?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type AuthTransferOutResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export type AuthTransferOutRequest$Outbound = {
  target_host?: string | undefined;
  nonce?: string | undefined;
  redirect?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const AuthTransferOutRequest$outboundSchema: z.ZodMiniType<
  AuthTransferOutRequest$Outbound,
  AuthTransferOutRequest
> = z.pipe(
  z.object({
    targetHost: z.optional(z.string()),
    nonce: z.optional(z.string()),
    redirect: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      targetHost: "target_host",
      gramSession: "Gram-Session",
    });
  }),
);

export function authTransferOutRequestToJSON(
  authTransferOutRequest: AuthTransferOutRequest,
): string {
  return JSON.stringify(
    AuthTransferOutRequest$outboundSchema.parse(authTransferOutRequest),
  );
}

/** @internal */
export const AuthTransferOutResponse$inboundSchema: z.ZodMiniType<
  AuthTransferOutResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
    });
  }),
);

export function authTransferOutResponseFromJSON(
  jsonString: string,
): SafeParseResult<AuthTransferOutResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthTransferOutResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthTransferOutResponse' from JSON`,
  );
}
